import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { Step, Stepper, StepLabel, } from '@material-ui/core/Stepper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import RaisedButton from '@material-ui/core/Button';
import FlatButton from '@material-ui/core/Button';
import { FirstStep, ChooseStep, AddContentMeetingStep, SecondStep, ThirdStep, CreationStep } from './Steps';
import MeetingsAndCollectionsController from './MeetingsAndCollectionsController';
import LocalizedStrings from '../../../Localization/localization';
import AppContext from '../../../../AppContext';

const CollectionSteps = [
    {
        title: LocalizedStrings.firstStep,
        component: FirstStep,
        validate: (contentData) => {
            let fields = ['name', 'language', 'previewImage', 'color'];
            for (let i = 0; i < fields.length; i++) {
                if (!contentData[fields[i]]) return false;
            }
            return true;
        },
    },
    {
        title: LocalizedStrings.secondStep,
        component: SecondStep,
        validate: () => {
            //No validation needed
            return true;
        },
    },
    {
        title: LocalizedStrings.create,
        component: ThirdStep,
        validate: (contentData) => {
            return contentData.resources.length > 0;
            //No validation needed
            // return true;
        },
    },
];

const MeetingSteps = [
    {
        title: LocalizedStrings.firstStep,
        component: FirstStep,
        validate: (contentData) => {
            let fields = ['name', 'language', 'previewImage', 'color', 'date'];
            for (let i = 0; i < fields.length; i++) {
                if (!contentData[fields[i]]) return false;
            }
            return true;
        },
    },
    {
        title: LocalizedStrings.chooseStep,
        component: ChooseStep,
        validate: (contentData) => {
            let fields = ['contentOrigin'];
            for (let i = 0; i < fields.length; i++) {
                if (!contentData[fields[i]]) return false;
            }
            return true;
        },
    },
    {
        title: LocalizedStrings.secondStep,
        component: AddContentMeetingStep,
        validate: () => {
            //No validation needed
            return true;
        },
    },
    {
        title: LocalizedStrings.create,
        component: ThirdStep,
        validate: (contentData) => {
            return (
                (contentData.contentOrigin === 'content' && contentData.resources.length > 0) ||
                (contentData.contentOrigin === 'collection' && contentData.collection !== '' && contentData.collection !== undefined)
            );
            //No validation needed
            //return true;
        },
    },
];

class CreationWizard extends Component {
    constructor(props) {
        super(props);
        let language = new AppContext().getLanguage();
        this.state = {
            finished: false,
            stepIndex: 0,
            contentData: {
                language: language,
                color: '#B3B3B3',
                resources: [],
            },
        };
        this._MeetingsAndCollectionsController = new MeetingsAndCollectionsController(this);
    }

    handleNext = () => {
        const { stepIndex } = this.state;
        const steps = this.getSteps();
        this.setState({
            stepIndex: stepIndex + 1,
            finished: stepIndex >= steps.length - 1,
        });
    };

    handlePrev = () => {
        const { stepIndex } = this.state;
        if (stepIndex > 0) {
            this.setState({ stepIndex: stepIndex - 1 });
        }
    };

    getSteps = () => {
        if (this.props.modalType === 'col') {
            return CollectionSteps;
        } else if (this.props.modalType === 'mtg') {
            return MeetingSteps;
        } else {
            return [];
        }
    };

    getStepContent(stepIndex) {
        let steps = this.getSteps();
        if (stepIndex > steps.length - 1) {
            stepIndex = steps.length - 1;
        }
        let result = steps[stepIndex];
        if (!result) {
            result = () => <div>{"You're a long way from home sonny jim!"}</div>;
        } else {
            result = result.component;
        }
        return result;
    }

    getValidation(stepIndex) {
        let steps = this.getSteps();
        let result = steps[stepIndex];
        if (!result) {
            result = () => true;
        } else {
            result = result.validate;
        }
        return result;
    }

    handleDataChange = (key, value) => {
        let newData = Object.assign({}, this.state.contentData);
        newData[key] = value;
        this.setState({ contentData: newData });
    };

    render() {
        const { finished, stepIndex } = this.state;
        // const contentStyle = { margin: '0 16px' };
        let StepComponent = this.getStepContent(stepIndex);
        let validate = this.getValidation(stepIndex);

        let steps = this.getSteps();
        return (
            <div style={{ width: '100%', maxWidth: 'calc(100vw - 50px)', margin: 'auto' }}>
                <Stepper
                    activeStep={stepIndex}
                    alternativeLabel={this.props.isSmartphone}
                    style={this.props.isSmartphone === true ? { padding: '0px' } : {}}
                >
                    {steps.map((step, i) => {
                        return (
                            <Step key={'step-' + i}>
                                <StepLabel>{step.title}</StepLabel>
                            </Step>
                        );
                    })}
                </Stepper>
                <div //style={contentStyle}
                >
                    {finished ? (
                        <CreationStep
                            _MeetingsAndCollectionsController={this._MeetingsAndCollectionsController}
                            contentData={this.state.contentData}
                            closeModal={this.props.closeModal}
                            modalType={this.props.modalType}
                            openContent={this.props.openContent}
                        />
                    ) : (
                        <div>
                            <StepComponent
                                onDataChange={this.handleDataChange}
                                contentData={this.state.contentData}
                                notify={this.props.notify}
                                _MeetingsAndCollectionsController={this._MeetingsAndCollectionsController}
                                modalType={this.props.modalType}
                                next={this.handleNext}
                            />
                            <div style={{ marginTop: 12, textAlign: 'right' }}>
                                <FlatButton
                                    label={LocalizedStrings.back}
                                    disabled={stepIndex === 0}
                                    onClick={this.handlePrev}
                                    style={{ marginRight: 12 }}
                                >
                                    {LocalizedStrings.back}
                                </FlatButton>
                                <RaisedButton
                                    label={stepIndex === this.getSteps().length - 1 ? LocalizedStrings.create : LocalizedStrings.next}
                                    //primary={true}
                                    color="primary"
                                    onClick={this.handleNext}
                                    disabled={!validate(this.state.contentData)}
                                >
                                    {stepIndex === this.getSteps().length - 1 ? LocalizedStrings.create : LocalizedStrings.next}
                                </RaisedButton>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
CreationWizard.propTypes = {
    isSmartphone: PropTypes.bool,
    notify: PropTypes.func,
    closeModal: PropTypes.func.isRequired,
    modalType: PropTypes.string,
    openContent: PropTypes.func.isRequired,
};

export default CreationWizard;
